import { useMutation } from '@apollo/client';
import { SupportInput } from '../../shared/types';
import { CITRIN_CREATE_SUPPORT, CreateSupportRequest, CreateSupportResponse } from '..';

type CreateMutationFunction = (request: SupportInput, file: any) => Promise<String>;
export const useSupportUserMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateSupportResponse, CreateSupportRequest>(CITRIN_CREATE_SUPPORT);

    const promiseMutation = async (request, file) => {
        const result = await mutation({
            variables: { request, file },
        });
        return result.data.CITRIN_MGT_supportUser;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
